export default {
    name: 'Metrics',
    data: () => ({
        metrics: [
            {
                text: 'Em orçamentos realizados pela plataforma',
                value: '+R$ 244,8 milhões'
            },
            {
                text: 'Clientes satisfeitos',
                value: '+5.776'
            },
            {
                text: 'Fornecedores cadastrados',
                value: '+4.899'
            }
        ]
    })
};
